function ensureI18nCacheIsCreated() {
    if (!('i18n' in window)) {
        window.i18n = {};
    }
}

/**
 * Replaces message key group separators (group.key) with underscores (group_key).
 */
function getFlattenedMessageKey(messageKey) {
    return messageKey.replace(/\./, '_');
}

function addMessageToCache(messageKey, message) {
    ensureI18nCacheIsCreated();
    const flattenedMessageKey = getFlattenedMessageKey(messageKey);
    window.i18n[flattenedMessageKey] = message;
}

function getCachedMessageByKey(messageKey) {
    ensureI18nCacheIsCreated();
    const flattenedMessageKey = getFlattenedMessageKey(messageKey);
    if (flattenedMessageKey in window.i18n) {
        return window.i18n[flattenedMessageKey];
    }
    return null;
}

/**
 * Gets flat map of messages by composite keys
 *
 * @param {String[]} messageKeys - List of message keys
 *
 * @return {String[]} - Returns an list of localized messages in the order they were requested
 */
function getCachedMessagesByKeys(messageKeys) {
    return messageKeys.map((key) => getCachedMessageByKey(key));
}

function resetCache() {
    window.i18n = {};
}

export { getCachedMessageByKey, getCachedMessagesByKeys, addMessageToCache, resetCache };
